import type { Identifier, RaRecord } from "react-admin";
import { navigateToBaseRoute, parsePathname } from "@/utils/route-utility";

/**
 * After creating a house-visit event, open its child dashboard at `/houseVisits/:id/#/`.
 */
export function redirectToHouseVisitDashboard(): (
  resource?: string,
  id?: Identifier,
  data?: Partial<RaRecord>
) => string {
  return (_resource, id, data) => {
    const raw = data?.id ?? id;
    const eventId = raw != null ? String(raw).trim() : "";
    if (!eventId) {
      return "list";
    }
    if (parsePathname().routeId !== eventId) {
      navigateToBaseRoute("houseVisits", eventId);
    }
    return "/";
  };
}
